import React from "react";
import Icon from "./Icon";

function ProjectCard({ item }) {
  const Tag = item.href ? "a" : "article";
  const linkProps = item.href ? { href: item.href, target: "_blank", rel: "noopener noreferrer" } : {};
  return (
    <Tag className={"proj" + (item.featured ? " proj-wide" : "")} {...linkProps}>
      <div className="proj-name">
        <Icon name={item.icon || "git-branch"} size={14} />
        {item.name}
      </div>
      <p className="proj-tag">{item.tagline}</p>
      <div className="proj-meta">
        {item.meta}{item.stack && item.stack.length > 0 ? " · " + item.stack.join(" / ") : ""}
      </div>
    </Tag>
  );
}

export default function Projects({ items }) {
  return (
    <div className="proj-grid">
      {items.map((p) => <ProjectCard key={p.name} item={p} />)}
    </div>
  );
}
